import { AppButton } from 'components';
import useUploadImage from 'hooks/API/POST/useUploadImage';
import useToaster from 'hooks/useToaster';
import { memo, useCallback, useEffect, useState } from 'react';
// import { AiOutlineCloudUpload } from 'react-icons/ai';

function AppImagePicker({
  accept,
  referenceKey,
  isPublic,
  handleChange,
  image,
  handleCancel,
  caption,
}) {
  const headers = {
    'X-access-control': isPublic ? 'public' : 'private',
    'X-reference-key': referenceKey,
  };
  const [file, setFile] = useState(null);
  const [uploadedData, setUploadedData] = useState(null);
  const { isLoading, isError, mutateAsync } = useUploadImage({ headers });

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function handleImageChange(event) {
    if (isLoading) return;

    const file = event.target.files[0];
    const url = event.target.value;

    if (!url) return;

    const reader = new FileReader();
    reader.onload = function () {
      setFile({
        url,
        file: reader.result,
        rawFile: file,
      });
    };
    reader.readAsDataURL(file);

    event.target.value = null; // This is enable to select the same image again
  }

  const upload = useCallback(async () => {
    const formData = new FormData();
    formData.append('file', file.rawFile);

    const response = await mutateAsync(formData);

    setUploadedData(response?.data);
  }, [file?.rawFile, mutateAsync]);

  useEffect(() => {
    if (uploadedData?.file) {
      handleChange({
        file,
        imageUrl: file?.file,
        logoUrl: uploadedData?.file,
        logoMeta: uploadedData,
      });
      setFile(null);
      setUploadedData(null);
    }
  }, [file, handleChange, uploadedData, uploadedData?.file]);

  useEffect(() => {
    if (file?.rawFile) {
      upload();
    }
  }, [file, upload]);

  return (
    <div className="d-flex">
      <div className="position-relative">
        <AppButton
          variantClass="file--clear my-2"
          onClick={() => {
            setFile(null);
            setUploadedData(null);
            handleChange(null);
            handleCancel();
          }}
        >
          X
        </AppButton>
        {(file?.file || image) && (
          <img className="image" src={file?.file || image} alt="Preview asset url" />
        )}

        {!(file?.file || image) && (
          <>
            <label
              htmlFor="preview-label-input"
              className="noperview"
              style={{
                background: '#e9d8fb',
                height: '100px',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '150px',
              }}
            >
              {isLoading ? 'Uploading...' : 'No Preview'}
              <input
                type="file"
                accept={accept}
                id="preview-label-input"
                onChange={handleImageChange}
                style={{ display: 'none' }}
              />
            </label>
          </>
        )}
      </div>

      <div className="d-inline-block">
        <>
          <label
            htmlFor="btnFileUpload"
            className="customBtnFileUpload btn-right-content upload ml-4"
          >
            {/* <AiOutlineCloudUpload /> Upload */}
            Upload
          </label>
          <input
            id="btnFileUpload"
            type="file"
            style={{ display: 'none' }}
            accept={accept}
            onChange={handleImageChange}
          />
        </>
        {caption && <p className="ml-4">{caption}</p>}
      </div>
    </div>
  );
}

AppImagePicker.defaultProps = {
  image: null,
  isPublic: true,
  referenceKey: 'ES_LOGO',
  accept: '.png,.jpg,.jpeg',
  handleChange: () => {},
  handleCancel: () => {},
};

export default memo(AppImagePicker);
